export enum ActionState {
    DISABLED = 'disabled',
    ENABLED = 'active',
}
